import { gql } from "@apollo/client";
import { currentVisitFragment } from "./details-graphql";

/**
 * @deprecated Do not use directly, use the generated query. Only exported to allow cache
 * writing in tests
 */
export const FIND_PATIENT_BY_CARD_ID = gql`
  query PatientDetails($uuid: String!, $searchWholeTerritory: Boolean) {
    patientByCardId(uuid: $uuid, searchWholeTerritory: $searchWholeTerritory) {
      patient {
        uuid
        card {
          id
          url
        }
        person {
          name {
            firstname
            middlename
            lastname
            fullname
          }
          dob
          gender
          addresses {
            country
            state
            subCounty
            ward
            street
          }
          nationality
          languages {
            locale
          }
          maritalStatus
          contactPoints {
            system
            ownership
            value
          }
          contacts {
            name {
              firstname
              middlename
              lastname
              fullname
            }
            relationship
            contactPoints {
              system
              value
            }
            address {
              country
              state
              subCounty
              ward
              street
            }        
          }
        }
        patientHasInsurance
        insurance {
          insuranceType
          insuranceNumber
          paymentUpToDate
          expiryDate
          visitValidation {
            expiryStrategy
          }
          insuranceProvider {
            name
            visitValidation {
              expiryStrategy
            }
          }
          insuranceDetails
        }
        education {
          isStudent
          school
          nemisNumber
        }
        consent {
          elephantUseOfAnonData
          productMarketing
          territoryUseOfData
          accessToHealthRecords
          healthcareComms
        }
        newToClinic
        clinic
        currentVisit {
          ...PatientCurrentVisit
        }
        registrationPayment {
          status
        }
        organisation
      }
      passportId
    }
  }
  ${currentVisitFragment}
`;

/** TODO: Replace with generated query */
export const CLINIC_QUERY = gql`
  query getClinic($clinicId: String!) {
    clinic(id: $clinicId) {
      uuid
      name
    }
  }
`;

export const ORGANISATION_QUERY = gql`
  query Organisation($organisationId: String!) {
    organisation(id: $organisationId) {
      name
      uuid
    }
  }
`;
